import React from 'react';

import {
  Intro,
  AcceptButton,
  RejectButton,
} from '@wetransfer/transfer/component/consent-manager';
import ConsentManagerDataOptIn from '@wetransfer/transfer/component/consent-manager/ConsentManagerDataOptIn/ConsentManagerDataOptIn';
import Router from '@wetransfer/transfer/modules/router';

export interface IntroProps {
  isLoggedIn: boolean;
}

export default function ConsentManagerIntro({ isLoggedIn }: IntroProps) {
  const handleOnClick = () => {
    Router.navigateTo(Router.getLastRoute('transfer', '/'));
  };
  const cookieWallVariant = 'panel';

  if (isLoggedIn) {
    return <ConsentManagerDataOptIn />;
  }

  return (
    <Intro isInPanel={true} cookieWallVariation={{ panel: true }}>
      <RejectButton
        onClick={handleOnClick}
        context="panel_intro_preference"
        cookieWallVariant={cookieWallVariant}
      />
      <AcceptButton
        onClick={handleOnClick}
        context="panel_intro_preference"
        cookieWallVariant={cookieWallVariant}
      />
    </Intro>
  );
}
